import * as React from 'react';

import { Card, CardSection } from '@lightspeed/flame/Card';
import { Box, Flex } from '@lightspeed/flame/Core';

import { SummaryCost } from 'root/apps/PurchaseOrder/NuorderOrdering/components/SummaryCost';
import { SummaryInfo } from 'root/apps/PurchaseOrder/NuorderOrdering/components/SummaryInfo';

export const Summary = () => {
  return (
    <Card marginTop={6} marginBottom={4}>
      <CardSection pt={4} pr={4} pb={4} pl={4}>
        <Flex>
          <SummaryInfo />
          <Box style={{ border: '0.5px solid', margin: '0 2em' }} className="cr-gray-100" />
          <SummaryCost />
        </Flex>
      </CardSection>
    </Card>
  );
};
